export default "__VITE_ASSET__CKo1k4VI__";